import React from "react";
import { Navigate } from "react-router-dom";
import Swal from "sweetalert2";

const AdminRoute = ({ children }) => {
  const token = localStorage.getItem("token");
  
  // Récupérer les informations utilisateur du localStorage
  const userData = localStorage.getItem("user");
  
  // Vérifie si l'utilisateur est connecté
  if (!token) {
    Swal.fire({
      icon: "warning",
      title: "Connexion obligatoire",
      text: "Veuillez vous connecter pour accéder à cette page",
      confirmButtonText: "OK",
      customClass: { confirmButton: "swal-btn-ok" },
    });
    return <Navigate to="/page accueil" replace />;
  }

  // Vérifie si les données utilisateur existent
  if (!userData) {
    Swal.fire({
      icon: "error",
      title: "Données utilisateur manquantes",
      text: "Veuillez vous reconnecter",
      confirmButtonText: "OK",
      customClass: { confirmButton: "swal-btn-ok" },
    });
    return <Navigate to="/" replace />;
  }

  try {
    // Parser les données utilisateur
    const user = JSON.parse(userData);
    console.log("User data:", user); 
    
    // Vérifier si l'utilisateur a le rôle admin
    if (user.role !== "admin") {
      Swal.fire({
        icon: "error",
        title: "Accès refusé",
        text: "Vous n'avez pas les droits nécessaires pour accéder à cette page.",
        confirmButtonText: "OK",
        customClass: { confirmButton: "swal-btn-ok" },
      });
      return <Navigate to="/" replace />;
    }


    return children;

  } catch (error) {
    console.error("Error parsing user data:", error);
    Swal.fire({
      icon: "error",
      title: "Erreur",
      text: "Erreur lors de la vérification des permissions",
      confirmButtonText: "OK",
      customClass: { confirmButton: "swal-btn-ok" },
    });
    return <Navigate to="/" replace />;
  }
};

export default AdminRoute;